function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { scrollTo } from './utils';
var __vue_script__ = {
  name: 'TimePickerSelect',
  props: {
    prefixCls: String,
    list: Array,
    selectedIndex: Number,
    type: String
  },
  data: function data() {
    return {
      active: false,
      duration: 120
    };
  },
  mounted: function mounted() {
    this.scrollToTarget(0);
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          active = this.active;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-select"), true), _defineProperty(_ref, "".concat(prefixCls, "-select-active"), active), _ref;
    }
  },
  methods: {
    optionClasses: function optionClasses(item, i) {
      var _ref2;

      var prefixCls = this.prefixCls,
          selectedIndex = this.selectedIndex;
      return _ref2 = {}, _defineProperty(_ref2, "".concat(prefixCls, "-select-option-selected"), i === selectedIndex), _defineProperty(_ref2, "".concat(prefixCls, "-select-option-disabled"), item.disabled), _ref2;
    },
    onSelect: function onSelect(item, idx) {
      if (item.disabled || idx === this.selectedIndex) {
        return;
      }

      this.$emit('on-select', item);
    },
    onMouseEnter: function onMouseEnter(e) {
      this.active = true;
      this.$emit('on-mouse-enter', e);
    },
    onMouseLeave: function onMouseLeave() {
      this.active = false;
    },
    scrollToTarget: function scrollToTarget(duration) {
      var $refs = this.$refs,
          selectedIndex = this.selectedIndex;
      var _$refs$options = $refs.options,
          options = _$refs$options === void 0 ? [] : _$refs$options,
          wrap = $refs.wrap;
      var idx = selectedIndex;

      if (options.length === 0) {
        return;
      }

      if (idx < 0) {
        idx = 0;
      }

      if (idx >= options.length) {
        idx = options.length - 1;
      }

      var target = options[idx];
      scrollTo(wrap, target.offsetTop, duration);
    }
  },
  watch: {
    selectedIndex: function selectedIndex(nVal, oVal) {
      if (nVal !== oVal) {
        this.scrollToTarget(this.duration);
      }
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "wrap",
    class: _vm.classes
  }, [_c('ul', {
    on: {
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave
    }
  }, _vm._l(_vm.list, function (item, i) {
    return _c('li', {
      key: i,
      ref: "options",
      refInFor: true,
      class: _vm.optionClasses(item, i),
      attrs: {
        "disabled": item.disabled
      },
      on: {
        "click": function click() {
          return _vm.onSelect(item, i);
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.value) + "\n    ")]);
  }), 0)]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "select.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);